define(function (require) {

    window.lpTag = window.lpTag || {};

    var TableViewController = require('web-agent-framework/TableViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var StatusWidgetViewController = ViewController.extend({
        ControllerName: 'StatusWidgetViewController',

        LPViewMap: {
            tablePlaceholder: ".lpview_status_table",
            chatState: ".lpview_chat_state",
            chatStateCurrent: ".lpview_chat_state_current",
            statusWidgetDropdown: ".lpview_status_widget_dropdown",
            statusDropdownButton: ".lpview_dropdown_button",
            chatStateShow: "status_widget_show"
        },

        initialize: function () {
            this.modelData = [
                {state: "online", description: this.translate("online")},
                {state: "occupied", description: this.translate("backIn5")},
                {state: "away", description: this.translate("away")}
            ];

            this.statusTable = new TableViewController({
                rowTemplateFile: "LP_status_item.html",
                lineClicked: this.lineClicked,
                dataRenderer: this.dataRenderer,
                modelData: this.modelData,
                focusedView: this.getFirstElement(this.LPViewMap.chatState),
                supportKeysNavigation: true,
                context: this
            });
            this.addViewController({viewController: this.statusTable, target: this.LPViewMap.tablePlaceholder});
            this.registerShortcut(this.shortcutType.STATUS_WIDGET, this.statusWidgetClicked, {position: "bottom"});
        },

        events: function () {
            this.bindModel({modelPath : "agent.chatAvailability", callback : this.updateStatusIcon});
            this.bindViewEvent({selector : this.LPViewMap.chatState, callback : this.statusWidgetClicked, DOMEvent : "click"});
            this.bindViewEvent({selector : this.LPViewMap.chatState, callback : this.blurStatusWidgetClicked, DOMEvent : "blur", ignoreChildBlur : true});

            this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
        },

        render: function () {
            this.getFirstElement(this.LPViewMap.chatState).tabIndex = 100;
        }
    });

    StatusWidgetViewController.prototype.lineClicked = function (data) {
        switch (data.rowData.state) {
            case "online":
                this.changeStatusOnline();
                break;
            case "occupied":
                this.changeStatusOccupied();
                break;
            case "away" :
                this.changeStatusAway();
                break;
            default :
                break;
        }
    };

    StatusWidgetViewController.prototype.updateStatusIcon = function (data) {
        var currentChatStateElement = this.getFirstElement(this.LPViewMap.chatStateCurrent);
        switch (data.newValue) {
            case "Online":
                this.removeClass(currentChatStateElement, ["brb", "away"], false);
                this.addClass(currentChatStateElement, "online");
                break;
            case "Occupied":
                this.removeClass(currentChatStateElement, ["online", "away"], false);
                this.addClass(currentChatStateElement, "brb");
                break;
            case "Away" :
                this.removeClass(currentChatStateElement, ["brb", "online"], false);
                this.addClass(currentChatStateElement, "away");
                break;
            default :
                break;
        }
        var that = this;
        setTimeout(function () {
            that.lpShow();
        }, 0);
        currentChatStateElement = null;
    };

    StatusWidgetViewController.prototype.statusWidgetClicked = function (e) {
        if (this.menuDisplayed) {
            this.hideStatusWidgetDropdown(e);
        } else {
            this.showStatusWidget(e);
        }
    };

    StatusWidgetViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return 1; // If the data is array, if no sections available, return 1
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length; // For array of arrays.
        },
        dataForSection: function (data, sectionIndex) {
            // The data will be injected to the section template.
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[rowIndex];
            return {state:rowData.state, description:rowData.description, rowData:rowData};
            // The data will be injected to the row template.
        }
    };

    StatusWidgetViewController.prototype.showStatusWidget = function (e) {
        // TODO: still needs revision of registering to shortcut mouse click (on table, or navigation with keys)
        this.addClass(this.LPViewMap.statusDropdownButton, this.LPViewMap.chatStateShow);
        this.addClass(this.LPViewMap.chatState, this.LPViewMap.chatStateShow);
        this.lpShow(this.LPViewMap.statusWidgetDropdown);
        this.menuDisplayed = true;
        this.stopPropagation(e);
        this.touchSession();

        this.statusTable.clearSelection();
        this.getFirstElement(this.LPViewMap.chatState).focus();
    };

    StatusWidgetViewController.prototype.blurStatusWidgetClicked = function (e) {
        this.hideStatusWidgetDropdown(e);
    };

    StatusWidgetViewController.prototype.hideStatusWidgetDropdown = function (e) {
        if (this.menuDisplayed) {
            this.removeClass(this.LPViewMap.statusDropdownButton, this.LPViewMap.chatStateShow);
            this.removeClass(this.LPViewMap.chatState, this.LPViewMap.chatStateShow);
            this.lpHide(this.LPViewMap.statusWidgetDropdown);
            this.menuDisplayed = false;
            this.stopPropagation(e);
            this.touchSession();
        }
    };

    StatusWidgetViewController.prototype.changeStatusOnline = function (e) {
        this.modelController.setAvailability({
            chatAvailability: "Online"
        });
        this.hideStatusWidgetDropdown(e);
    };

    StatusWidgetViewController.prototype.changeStatusOccupied = function (e) {
        this.modelController.setAvailability({
            chatAvailability: "Occupied"
        });
        this.hideStatusWidgetDropdown(e);
    };

    StatusWidgetViewController.prototype.changeStatusAway = function (e) {
        this.modelController.setAvailability({
            chatAvailability: "Away"
        });
        this.hideStatusWidgetDropdown(e);
    };

    StatusWidgetViewController.prototype.statusChanged = function (data) {
        if (typeof data.newValue !== 'undefined' && data.newValue !== 'loggedIn') {
            this.dispose();
        }
    };

    return StatusWidgetViewController;

});
